import Vue from 'vue';
import App from './app';
import store from './store';
import routeManager from './router';
import 'modernizr';
// import Snotify from 'vue-snotify';
// You also need to import the styles. If you're using webpack's css-loader, you can do so here:
//import 'vue-snotify/styles/material.css';
//Vue.use(Snotify);
Vue.config.productionTip = false;

new Vue({
  store,
  routeManager,
  render: h => h(App),
}).$mount('#app');
